import SbEditable from "@mkt/ui/components/common/SbEditable"
import { storyblokEditable } from "@storyblok/react"
import { Text } from "iq-blueberry"
import { Button } from "iq-blueberry"
import { render } from "storyblok-rich-text-react-renderer"
import Img from "@mkt/ui/components/common/Img"
import * as S from "./styles.js"
import assertAssetURL from "@mkt/utils/assertAssetUrl.js"

const TwoCards = ({ content, showLessButton, handleClick }) => {
  return (
    <SbEditable css={S.twoCards} content={content}>
      <div css={S.twoCardsContainer} {...storyblokEditable(content)}>
        <Text
          css={S.twoCardsTitle}
          as="h2"
          weight="700"
          variant="heading-three"
        >
          {render(content?.title)}
        </Text>
        <div css={S.twoCardsSubtitle}>{render(content?.text)}</div>
        <div css={S.twoCardsContent}>
          {content?.cards?.map(({ title, text, icon_list }) => {
            return (
              <div css={S.twoCardsItem}>
                <Text
                  css={S.twoCardsItemTitle}
                  as="h3"
                  weight="700"
                  variant="heading-five"
                >
                  {title}
                </Text>
                {icon_list.length > 0 ? (
                  <div css={S.twoCardsList}>
                    {icon_list?.map(({ icon, title, text }) => {
                      return (
                        <div css={S.twoCardsListItem}>
                          <div css={S.twoCardsListItemTitle}>
                            <Img
                              src={assertAssetURL(icon.filename)}
                              alt={`Consumidor Positivo - ${title}`}
                              width="24"
                              height="24"
                            />
                            {title}
                          </div>
                          <p>{text}</p>
                        </div>
                      )
                    })}
                  </div>
                ) : (
                  <div css={S.twoCardsItemText}>{render(text)}</div>
                )}
              </div>
            )
          })}
        </div>
        {content?.text_bottom && (
          <div css={S.twoCardsTextBottom}>{render(content?.text_bottom)}</div>
        )}
        {showLessButton && (
          <div css={S.button(false)}>
            <Button
              type="secondary"
              color="white"
              justify="center"
              expand="x"
              onClick={handleClick}
            >
              Ver menos
            </Button>
          </div>
        )}
      </div>
    </SbEditable>
  )
}

export default TwoCards
